import { MasterDialog } from "#common/Dialog/Dialog"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { jobProfileColaboradoresGet } from "#job-profile/services/api"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import { Box, Typography } from "@mui/material"
import Avatar from "@mui/material/Avatar"
import Divider from "@mui/material/Divider"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import ListItemText from "@mui/material/ListItemText"
import * as React from "react"
import { Fragment, useMemo } from "react"
export default function ColaboradoresDialog({ open, setOpen, profileData }) {
	const buttons = useMemo(
		() => [
			{
				label: "Cerrar",
				onClick: () => {
					setOpen(false)
				},
			},
		],
		[setOpen]
	)

	return (
		<Fragment>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: (
						<>
							Colaboradores con perfil <strong>{profileData.nombre}</strong>
						</>
					),
					buttons,
					maxWidth: "md",
				}}
			>
				<Colaboradores autoFetch={open} profileData={profileData} />
			</MasterDialog>
		</Fragment>
	)
}

function Colaboradores({ autoFetch, profileData }) {
	const params = useMemo(() => ({ profileId: profileData.id }), [profileData.id])
	const { data, loading, error } = useApi(jobProfileColaboradoresGet, {
		autoFetch,
		params,
	})
	const colaborador = data?.data || []

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	if (!colaborador.length)
		return (
			<Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
				<Typography variant="h5">No hay colaboradores</Typography>
			</Box>
		)

	return colaborador.map((item) => {
		return (
			<List sx={{ width: "100%", bgcolor: "background.paper" }} key={item.id}>
				<ListItem alignItems="flex-start">
					<ListItemAvatar
						sx={{
							mr: 3, // 👈 margen a la derecha
						}}
					>
						<Avatar
							alt={item.full_name}
							src={item.photo}
							sx={{
								width: 110,
								height: 110,
							}}
						>
							<AccountCircleIcon
								sx={{
									width: 110,
									height: 110,
								}}
							/>
						</Avatar>
					</ListItemAvatar>
					<ListItemText
						primary={item.created_at}
						secondary={
							<React.Fragment>
								<Typography
									sx={{ display: "inline" }}
									component="span"
									variant="h5"
									color="text.primary"
								>
									{item.full_name}
								</Typography>
								<Typography variant="subtitle1" color="text.secondary">
									No Empleado: <strong>{item.no_empleado}</strong>
								</Typography>
								<Typography variant="subtitle1" color="text.secondary">
									Sucursal: <strong>{item.sucursal}</strong>
								</Typography>
							</React.Fragment>
						}
					/>
				</ListItem>
				<Divider variant="inset" component="li" />
			</List>
		)
	})
}
